
import { RouteObject } from "react-router-dom"
import FaPiaoType from '../components/faPiaoCenter/FaPiaoType';
import FaPiaoSupplier from '../components/faPiaoCenter/FaPiaoSupplier';
import FaPiao from '../components/faPiaoCenter/FaPiao';

const faPiaoCenterRouter: RouteObject[] = [
    {
        path: "/faPiaoType",
        element: <FaPiaoType />,
    },
    {
        path: "/faPiaoSupplier",
        element: <FaPiaoSupplier />,
    },
    {
        path: "/faPiao",
        element: <FaPiao />,
    },

];


export default faPiaoCenterRouter;